export default __webpack_public_path__ + "static/media/Path3425.53bd076f.svg";